// action - state management
import * as actionTypes from "../actions/actionTypes";

export const initialState = {
  revenueSummary: {},
};

// ==============================|| COMPANY REDUCER ||============================== //

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMPANY_REVENUE_SUMMARY:
      return {
        ...state,
        revenueSummary: action.revenueSummary,
      };
    default:
      return state;
  }
};

export default companyReducer;
